import { Component, Input, NgModule, OnInit } from '@angular/core';
import { UserService } from 'src/app/shared/services/user/user.service';
import { NotificationService } from '../../services/notification.service';
import { CommonModule } from '@angular/common';
import { DxCheckBoxModule } from 'devextreme-angular';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-subscribe-emails',
  templateUrl: './subscribe-emails.component.html',
})
export class SubscribeEmailsComponent implements OnInit {
  @Input() userId: number;
  subList = {};
  index: number;
  emailList = {
    id: null,
    user_id: null,
    fav_listings: true,
    monthly_executive: true,
    order_notifications: true,
    trending_products: true,
    weekly_changes: true,
  };

  constructor(
    private userService: UserService,
    private notifyService: NotificationService,
  ) {}

  ngOnInit() {
    this.emailList.user_id = this.userId;
    this.getEmailSubscription();
  }

  getEmailSubscription() {
    this.userService.get_email_subscription(this.userId).subscribe(
      result => (this.emailList = result.data),
      () => this.createEmailSubscription(),
    );
  }

  /** The profile's one Save calls this and reports the result. */
  save(): Observable<unknown> {
    return this.emailList.id
      ? this.userService.update_email_subscription(this.emailList.id, this.emailList)
      : this.userService.create_email_subscription(this.emailList);
  }

  createEmailSubscription() {
    this.userService.create_email_subscription(this.emailList).subscribe(
      () => this.notifyService.showNotify('Saved', 'success'),
      error => this.notifyService.showNotify(error, 'error'),
    );
  }
}

@NgModule({
  imports: [CommonModule, DxCheckBoxModule],

  declarations: [SubscribeEmailsComponent],
  exports: [SubscribeEmailsComponent],
})
export class SubscribeEmailsModule {}
